import { Breakpoints, TextAppearance, TextCustomProps, TextLineHeight, TextSize, TextTag, TextWeight } from "@vw-marketing/us-components";

export const reviewsLinkStyle: TextCustomProps = {
    appearance: TextAppearance.copy100,
    tag: TextTag.span,
    style: {
        [Breakpoints.default]: {
            fontSize: TextSize.TextSize10,
            lineHeight: TextLineHeight.TextLineHeight12
        },
        [Breakpoints.b960]: {
            fontSize: TextSize.TextSize14,
            lineHeight: TextLineHeight.TextLineHeight16
        }
    }
}

export const dealerNameReviewsLinkStyle: TextCustomProps = {
    appearance: TextAppearance.copy200,
    tag: TextTag.span,
    style: {
        [Breakpoints.default]: {
            fontSize: TextSize.TextSize14,
            lineHeight: TextLineHeight.TextLineHeight16,
            fontWeight: TextWeight.bold
        },
        [Breakpoints.b960]: {
            fontSize: TextSize.TextSize18,
            lineHeight: TextLineHeight.TextLineHeight24,
            fontWeight: TextWeight.bold
        }
    }
}